import React from 'react';

import colors from '../sl-colors';

interface Props extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

export default function Dash({ color = colors.gray.DEFAULT, ...props }: Props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path d="M3 7H10" stroke={color} strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}
